import './App.css';
import Container from './components/Container';

function App() {
  return (
      <main className="App">
        <Container />
      </main>
  );
}

export default App;
